/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIEmployeeGroup
 */
export interface APIEmployeeGroup {
    /**
     * 
     * @type {string}
     * @memberof APIEmployeeGroup
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof APIEmployeeGroup
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof APIEmployeeGroup
     */
    type?: string;
}

/**
 * Check if a given object implements the APIEmployeeGroup interface.
 */
export function instanceOfAPIEmployeeGroup(value: object): value is APIEmployeeGroup {
    return true;
}

export function APIEmployeeGroupFromJSON(json: any): APIEmployeeGroup {
    return APIEmployeeGroupFromJSONTyped(json, false);
}

export function APIEmployeeGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIEmployeeGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function APIEmployeeGroupToJSON(value?: APIEmployeeGroup | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'type': value['type'],
    };
}

